var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { FieldBasics } from '@/components/mambas';
import lodash from 'lodash';
import { Component, Inject, Mixins } from 'vue-property-decorator';
let default_1 = class default_1 extends Mixins(FieldBasics) {
    constructor() {
        super(...arguments);
        // 搜索关键字
        this.searchValue = '';
        this.originalData = [];
    }
    get isShowSearch() {
        return lodash.get(this._fieldProps, 'showSearch', false);
    }
    get checkedKeyOnlyChild() {
        return lodash.get(this._fieldProps, 'checkedKeyOnlyChild', false);
    }
    highlight(text) {
        return text.replace(new RegExp(`(${this.searchValue})`, 'gi'), '<span style="color: red">$1</span>');
    }
    // 选中的值
    onCheck(checkedKeys, e) {
        // 只取叶子节点
        if (!lodash.isEmpty(checkedKeys) && this.checkedKeyOnlyChild) {
            this.value = lodash
                .map(e.checkedNodes, (node) => {
                if (lodash.size(lodash.get(node, 'componentOptions.children')) === 0) {
                    return lodash.get(node, 'key');
                }
            })
                .filter((key) => key);
        }
    }
    // 搜索过滤树
    filterTreeData(treeData, keyword) {
        return lodash
            .map(treeData, (node) => {
            const title = node.title;
            if (lodash.size(node.children) > 0) {
                const children = this.filterTreeData(node.children, keyword);
                if (children.length > 0) {
                    return { ...node, title, children };
                }
                return null;
            }
            if (title.includes(keyword)) {
                return { ...node, title };
            }
            return null;
        })
            .filter((node) => node !== null);
    }
    onSearch(value) {
        this.searchValue = value;
        if (value) {
            this.dataSource = this.filterTreeData(this.originalData, value);
        }
        else {
            // this.onRequest();
            this.dataSource = this.originalData;
        }
    }
    // 加载数据源
    async onRequest() {
        this.spinning = true;
        try {
            const res = await lodash.invoke(this, '_fieldProps.request', lodash.cloneDeep(this.formState));
            this.dataSource = lodash.cloneDeep(res);
            this.originalData = lodash.cloneDeep(res);
        }
        catch (error) {
            console.error('LENG ~ onRequest', error);
        }
        this.spinning = false;
    }
    async mounted() {
        this.onRequest();
        this.onLinkage();
        if (this.debug) {
            console.log('');
            console.group(`Field ~ ${this.entityKey} ${this._name} `);
            console.log(this);
            console.groupEnd();
        }
    }
};
__decorate([
    Inject()
], default_1.prototype, "formState", void 0);
__decorate([
    Inject()
], default_1.prototype, "PageEntity", void 0);
__decorate([
    Inject({ default: '' })
], default_1.prototype, "formType", void 0);
default_1 = __decorate([
    Component({ components: {} })
], default_1);
export default default_1;
